$('.values__list .value__title').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');
    $('.values__list .value__title').removeClass('active');
    $('.value__description').removeClass('active');
    $(this).addClass('active');
    $(tab_id).addClass('active');
});

$('.value__description').each(function() {
    var height = $(this).outerHeight();
    $(this).attr('data-height', height);
});

if (window.matchMedia("(min-width: 992px)").matches) {
    var tab1Height = $('#tab-1').attr('data-height');
    $('.values__list').css('height', tab1Height);
}

$( '.values__nav-desktop .value__nav-title' ).hover (
    function() {
        var tab_id = $(this).attr('data-tab');
        $('.values__nav-desktop .value__nav-title').removeClass('active');
        $('.value__description').removeClass('active');
        $(this).addClass('active');
        $(tab_id).addClass('active');
        var myheight = $(tab_id).attr('data-height');
        $('.values__list').animate({ height: myheight}, 200);
        $('.values__nav-desktop').addClass('is-opened');
    }, function() {
        var tab_id = $(this).attr('data-tab');
        $('.values__list').animate({ height: 0 }, 200);
        $(this).removeClass('active');
        $(tab_id).removeClass('active');
        $('.values__nav-desktop').removeClass('is-opened');
    }
);

// Tabs Solutions
$('.solution__tab-title').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');
    $('.solution__tab-title').removeClass('active');
    $('.solution__tab-content').removeClass('active');
    $(this).addClass('active');
    $(tab_id).addClass('active');
    if (window.matchMedia("(max-width: 1005px)").matches) {
        var padding = "0px";
        $('.solutions__list').css('padding-bottom', padding);
        } else {
        var padding = $('.solution__tab-content.active').outerHeight();
        $('.solutions__list').css('padding-bottom', padding);
        }
});
if (window.matchMedia("(max-width: 1005px)").matches) {
    var padding = "0px";
    $('.solutions__list').css('padding-bottom', padding);
} else {
    var padding = $('.solution__tab-content.active').outerHeight();
    $('.solutions__list').css('padding-bottom', padding);
}





